import PropTypes from 'prop-types';
import { useAuthorization } from './useAuthorization';

const Authorization = ({ action, renderNoAccess = null, children }) => {
  const auth = useAuthorization();

  if (!auth.can(action)) {
    return renderNoAccess;
  }

  return children;
};

Authorization.propTypes = {
  action: PropTypes.string.isRequired,
  renderNoAccess: PropTypes.node,
  children: PropTypes.node
};

export default Authorization;
